var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSura(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 38.162,
    viewBox: "0 0 110 38.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 19.081)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55 -19.081)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.054)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M353.405,131.841c.047-.07,0-.117-.047-.141a55.8,55.8,0,0,1-9.61,2.11,58.216,58.216,0,0,1-5.813.516l-.539.047a.117.117,0,0,0-.117.094c-.023.047.023.07.047.094a4.515,4.515,0,0,0,2.32,1.1,19.569,19.569,0,0,0,6.985-1.055A31.2,31.2,0,0,0,353.405,131.841Z",
    transform: "translate(-337.273 -100.837)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M365.957,137.6a22.828,22.828,0,0,1-5.321,2.555,42.918,42.918,0,0,1-7.149,1.852.141.141,0,0,0-.094.094.117.117,0,0,0,.023.094,3.117,3.117,0,0,0,1.641.609,8.368,8.368,0,0,0,2.977-.328,17.907,17.907,0,0,0,3.117-1.266,20.179,20.179,0,0,0,2.906-1.711A9.141,9.141,0,0,0,366,137.717C366.027,137.647,366,137.623,365.957,137.6Z",
    transform: "translate(-349.614 -105.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M357.325,28.225a4.688,4.688,0,0,0,2.063,1.242h.07l18.048,4.782,3.516.961c.07,0,.094-.023.094-.07a.094.094,0,0,0-.047-.07c-2.344-.938-16.853-6.516-22.314-8.6l-2.3-.867c-.07,0-.117,0-.141.023a.117.117,0,0,0-.023.094,4.9,4.9,0,0,0,.609,1.945A3.562,3.562,0,0,0,357.325,28.225Z",
    transform: "translate(-351.834 -19.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M360.6,3.113A3.61,3.61,0,0,0,361.653,4l.539.3,1.289.656c.727.375,11.6,5.438,13.2,6.235l4.571,2.227c.07.023.117,0,.094-.094-2.016-1.266-9.8-6.164-15.353-9.587L362,1.332l-.727-.445L359.965.043q-.105-.035-.141,0a.07.07,0,0,0-.047.07,5.3,5.3,0,0,0,.281,1.992,4.758,4.758,0,0,0,.539,1.008Z",
    transform: "translate(-354.497 -0.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M387.108,148h-.07a14.485,14.485,0,0,1-5.344,3.047.117.117,0,0,0-.094.094.141.141,0,0,0,.07.117c.141.07,1.2.633,3.235-.375a4.849,4.849,0,0,0,2.25-2.766C387.2,148.047,387.155,148,387.108,148Z",
    transform: "translate(-371.21 -113.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M417.237,84.5l-7.407,1.922-5.6,1.477c-.3.07-.187.211-.164.258l.445.727a1.238,1.238,0,0,0,1.688.492c.117-.047,10.618-4.43,11.087-4.735.07-.047.023-.094.023-.117S417.26,84.5,417.237,84.5Z",
    transform: "translate(-388.377 -64.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M419.034,115.6h-.07c-1.383,1.149-3.516,3-5.7,4.875a1.491,1.491,0,0,0-.375.844,12.055,12.055,0,0,1-.469,1.43c-.07.188.023.258.211.07,1.688-1.828,5.438-5.954,6.446-7.149C419.1,115.647,419.057,115.6,419.034,115.6Z",
    transform: "translate(-394.791 -88.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M388.293,58.26,363.682,53.9l-.117.047a.235.235,0,0,0,0,.141,4.219,4.219,0,0,0,2.789,2.813l.492.094,21.4,1.406c.047,0,.094-.023.094-.07A.07.07,0,0,0,388.293,58.26Z",
    transform: "translate(-357.394 -41.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M403.922,78H393.351l-8.016.047-.094.047a.07.07,0,0,0,0,.094,3.563,3.563,0,0,0,.656,1.055A3.211,3.211,0,0,0,387.89,80.3h.516l15.517-2.133a.083.083,0,0,0,0-.164Z",
    transform: "translate(-373.984 -59.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M423.708,93.2l-5.883,3.563c-1.266.773-2.836,1.641-3.656,2.156-.094.07-.164.047-.117.3a3.352,3.352,0,0,1,.07.539c.094,1.219.586,1.078,1.313.516l.094-.07c2.531-2.086,7.219-6.024,8.251-6.891A.082.082,0,0,0,423.708,93.2Z",
    transform: "translate(-396.044 -71.361)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.643)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M242.038,36.9c-5.039,0-9.774,3.7-9.962,10.946C231.889,54.409,235.311,59,241.1,59c4.758,0,6.422-3.3,6.422-3.3C247.8,57.925,249,58.6,251.39,58.6V36.9Zm5.25,12.774c0,3-1.711,5.86-5.461,5.86-3.352,0-5.743-2.25-5.579-7.641s2.649-7.477,5.954-7.477h5.086Z",
    transform: "translate(-177.674 -36.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M98.141,36.9V51.924c0,2.2-1.8,3.3-4.2,3.3s-4.172-1.1-4.172-3.3V40.674c0-3.211-2.016-3.774-3.774-3.774V52.862c0,4.032,3.633,6,7.852,6s8.133-1.969,8.133-6V41.189C101.962,38.025,100.767,36.9,98.141,36.9Z",
    transform: "translate(-65.842 -36.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.157,46.627,6.54,45.338C5.274,44.986,4.1,44.424,4.1,42.877s.984-2.414,3.047-2.414h4.1c1.828,0,3.985-.609,3.985-3.563H7.5C2.742,36.923,0,39.338,0,42.783s2.039,5.016,5.672,6L9.7,49.862a2.613,2.613,0,0,1,2.25,2.555c0,1.641-1.031,2.6-3.539,2.625l-7.735.07V58.6h7.9c4.758,0,7.5-2.555,7.5-5.93S14.743,47.588,11.157,46.627Z",
    transform: "translate(0 -36.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M183.722,36.9c-4.688,0-7.922,2.719-7.922,8.3V58.581h3.774V45.08c0-2.883,1.547-4.594,4.477-4.594h1.125c3.3,0,3.844-1.711,3.844-3.563Z",
    transform: "translate(-134.594 -36.9)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSura);
export default __webpack_public_path__ + "static/media/logo-sura.0e9987fd71d02b999896e97a1a296282.svg";
export { ForwardRef as ReactComponent };